<template>
  <v-btn class="mr-2" icon="mdi-card-search" @click="isUrlInputOpen = true">
  </v-btn>
  <v-dialog v-model="isUrlInputOpen" max-width="600px">
    <v-card>
      <v-card-title>Enter URL</v-card-title>
      <v-card-text>
        <UrlInputForm @url-submitted="closeUrlInput" />
      </v-card-text>
      <v-divider></v-divider>
      <ScrapeControls></ScrapeControls>
      <v-divider></v-divider>
      <v-card-text v-if="hasHistory" class="pt-1">
        <UrlHistoryList @select-url="closeUrlInput" />
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script lang="ts" setup>
  import { ref, computed } from 'vue';
  import { useUrlHistoryStore } from '@/store/urlHistoryStore';
  import UrlInputForm from '@/components/UrlInputForm.vue';
  import UrlHistoryList from '@/components/UrlHistoryList.vue';
  import ScrapeControls from './ScrapeControls.vue';

  const isUrlInputOpen = ref(false);
  const urlHistoryStore = useUrlHistoryStore();

  // Computed property to check if the history is not empty
  const hasHistory = computed(() => urlHistoryStore.urls.length > 0);

  function closeUrlInput() {
    isUrlInputOpen.value = false;
  }
</script>
